import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TradeListings from "../components/TradeListings";
import "./BrowseTrades.css";

const safeLower = (v) => String(v ?? "").trim().toLowerCase();

const BrowseTrades = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const filters = useMemo(() => {
    const fromStateCond = safeLower(location.state?.condition || "");
    try {
      const sp = new URLSearchParams(location.search || "");
      const q = String(sp.get("q") || "").trim();
      const category = String(sp.get("category") || "").trim();
      const condRaw = safeLower(sp.get("cond") || fromStateCond || "");
      const cond = condRaw === "new" || condRaw === "used" ? condRaw : "all";
      return { q, category, cond };
    } catch {
      return { q: "", category: "", cond: "all" };
    }
  }, [location.search, location.state]);

  const hasActiveFilters =
    !!filters.q || !!filters.category || filters.cond !== "all";

  const setCond = (cond) => {
    const c = safeLower(cond);
    const next = c === "new" || c === "used" ? c : "all";

    const sp = new URLSearchParams(location.search || "");
    if (next === "all") sp.delete("cond");
    else sp.set("cond", next);

    navigate(
      {
        pathname: location.pathname,
        search: sp.toString() ? `?${sp.toString()}` : "",
      },
      {
        replace: true,
        state: { ...(location.state || {}), condition: next },
      }
    );
  };

  const clearAllFilters = () => {
    navigate("/market/browse", { replace: true });
  };

  return (
    <div className="browse-premium-page">
      <div className="browse-premium-shell">
        <section className="browse-topbar">
          <div className="browse-topbar__left">
            <h1 className="browse-topbar__title">Browse listings</h1>
            <p className="browse-topbar__subtitle">
              Premium cash-first marketplace
            </p>
          </div>

          <div className="browse-topbar__right">
            {!hasActiveFilters ? (
              <span className="browse-topbar__status">
                Showing all available listings
              </span>
            ) : (
              <div className="browse-filterSummary">
                {filters.q ? (
                  <span className="browse-filterChip">Search: {filters.q}</span>
                ) : null}
                {filters.category ? (
                  <span className="browse-filterChip">
                    Category: {filters.category}
                  </span>
                ) : null}
                {filters.cond !== "all" ? (
                  <span className="browse-filterChip">
                    Condition: {filters.cond === "new" ? "New" : "Pre-owned"}
                  </span>
                ) : null}
              </div>
            )}

            {hasActiveFilters ? (
              <button
                type="button"
                className="browse-clearBtn"
                onClick={clearAllFilters}
              >
                Clear all
              </button>
            ) : null}
          </div>
        </section>

        <section className="browse-toolbar">
          <div className="browse-toolbar__left">
            <p className="browse-toolbar__hint">
              Refined discovery view with premium cards and cash-first listings.
            </p>
          </div>

          <div className="browse-toolbar__right">
            <button
              type="button"
              className={`browse-chip ${filters.cond === "all" ? "is-active" : ""}`}
              onClick={() => setCond("all")}
            >
              All
            </button>
            <button
              type="button"
              className={`browse-chip ${filters.cond === "new" ? "is-active" : ""}`}
              onClick={() => setCond("new")}
            >
              New
            </button>
            <button
              type="button"
              className={`browse-chip ${filters.cond === "used" ? "is-active" : ""}`}
              onClick={() => setCond("used")}
            >
              Pre-owned
            </button>
          </div>
        </section>

        <section className="browse-listingsWrap">
          <TradeListings
            publicMode
            publicLimit={80}
            publicSearchTerm={filters.q}
            publicCategoryKey={filters.category || null}
            conditionFilter={filters.cond}
          />
        </section>
      </div>
    </div>
  );
};

export default BrowseTrades;